import { defaultTo, map, path, pipe, prop, sum } from 'ramda'

import { humanizeSize } from '@Common/Utils/Files'

export const calculateBundleSize = pipe(prop('swComponents'), defaultTo([]), map(path(['swComponentStatus', 'sizeInBytes'])), sum, humanizeSize)
